import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertTriangle, CalendarPlus, X } from "lucide-react";
import { toast } from "sonner";

const fmt = (d) => new Date(d + "T12:00").toLocaleDateString("en", { weekday: "short", month: "short", day: "numeric" });

export const UnbookedVisitsAlert = ({ onBook, refreshKey }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/unbooked-visits").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  const dismiss = async (id) => { try { await api.delete(`/admin/unbooked-visits/${id}`); load(); } catch (e) { toast.error(apiErr(e)); } };
  if (!rows.length) return null;
  return (
    <div className="lg:col-span-2 rounded-2xl border-2 border-coral/40 bg-coral/5 p-4" data-testid="admin-unbooked-alert">
      <p className="font-display font-extrabold text-navy flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-coral" />Unbooked visits ({rows.length})</p>
      <p className="text-xs text-slate-500 mb-3">These explorers were scanned or flagged at the Register on a day they had no booking. Tap Book to add the day (past days are allowed) — it disappears once booked.</p>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.id} className="flex flex-wrap items-center gap-2 bg-white rounded-xl border border-slate-200 px-3 py-2" data-testid={`unbooked-row-${r.id}`}>
            <div className="flex-1 min-w-[180px]">
              <p className="font-semibold text-navy text-sm">{r.child_name} <span className="text-xs text-slate-400">{r.explorer_id}</span></p>
              <p className="text-xs text-slate-500">{fmt(r.date)} · {r.parent_name}{r.parent_phone ? ` · ${r.parent_phone}` : ""} · flagged via {r.source}{r.logged_by ? ` by ${r.logged_by}` : ""}</p>
            </div>
            <Button size="sm" onClick={() => onBook(r.parent_id)} className="rounded-full bg-gold text-navy font-bold h-8 hover:bg-gold/90" data-testid={`unbooked-book-${r.id}`}><CalendarPlus className="w-3.5 h-3.5 mr-1" />Book</Button>
            <Button size="sm" variant="ghost" onClick={() => dismiss(r.id)} className="h-8 text-slate-400" title="Dismiss" data-testid={`unbooked-dismiss-${r.id}`}><X className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
};
